<script>
export default {
  name: "CrewAccounts"
}
</script>

<template>
  <router-view></router-view>
</template>

<style scoped>
</style>